import Caption from '@zenbusiness/common-components/Caption';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';

import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import withStyles from '@mui/styles/withStyles';

export const Section = styled(Grid)(({ theme }) => ({
  '& > p': {
    margin: '0 0 0.25rem 0',
    color: theme.palette.focus60.main
  },
  [theme.breakpoints.up('md')]: {
    marginBottom: 20,
    maxWidth: '100%'
  }
}));

export const SectionItems = styled(Grid)(({ theme }) => ({
  display: 'grid',
  gap: '1.5rem',
  gridTemplateColumns: '1fr',
  padding: '1.5rem 0 1.5rem 1.5rem',
  [theme.breakpoints.up('md')]: {
    padding: '2rem'
  }
}));

export const SectionContent = styled(Grid)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  '& pre': {
    overflow: 'hidden',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    marginTop: 0,
    marginBottom: '0.5rem',
    fontFamily: theme.typography.fontFamily
  }
}));

export const SectionContainer = styled(Grid)(({ theme }) => ({
  display: 'grid',
  border: `0.063rem solid ${theme.palette.focus30.main}`,
  borderRadius: '0.75rem',
  '& > div:not(:last-child)': {
    borderBottom: `0.09rem solid ${theme.palette.focus30.main}`
  }
}));

export const ItemTitleSubLabel = styled(Caption)(() => ({
  display: 'inline-block',
  verticalAlign: 'middle',
  textTransform: 'uppercase'
}));

export const TextTitleSubLabel = styled(Text)(() => ({
  display: 'inline-block',
  verticalAlign: 'middle',
  textTransform: 'uppercase'
}));

export const TooltipStyled = styled(Tooltip)(({ theme }) => ({
  tooltip: {
    padding: '1rem',
    background: theme.palette.focus80.main,
    fontSize: 14,
    borderRadius: '1rem',
    width: 'fit-content',
    [theme.breakpoints.up('md')]: {
      maxWidth: 300
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 400
    }
  },
  '& img': {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%'
  }
}));

export const TooltipWithStyles = withStyles((theme) => (
  {
    tooltip: {
      padding: '1rem',
      background: theme.palette.focus80.main,
      fontSize: 14,
      lineHeight: '17px',
      borderRadius: '1rem',
      width: 'fit-content',
      [theme.breakpoints.up('md')]: {
        maxWidth: 300
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: 400
      }
    }
  }
))(Tooltip);

export const TooltipContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: theme.palette.primary.contrastText,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    '& img': {
      minWidth: 64,
      marginRight: 16
    }
  }
}));

export const Root = styled('div')(({ theme }) => ({
  paddingTop: 16,
  [theme.breakpoints.up('md')]: {
    padding: 40
  }
}));

export const ItemTitle = styled('div')(({ theme }) => ({
  ...theme.typography.caption_mediumRegular,
  color: theme.palette.keyGreys.fossil,
  marginBottom: 5,
  marginTop: 9,

  [theme.breakpoints.up('md')]: {
    ...theme.typography.body_smallRegular
  }
}));

export const TooltipLabel = styled('div')(() => ({
  display: 'flex',
  verticalAlign: 'middle',
  '& img': {
    marginLeft: 8,
    height: 'fit-content'
  }
}));

export const ProfileHead = styled(Title)(({ theme }) => ({
  fontWeight: 800,
  fontFamily: 'Montserrat',
  marginBottom: 26,
  [theme.breakpoints.up('md')]: {
    marginBottom: 48
  }
}));

export const SectionTitle = styled(Title)(({ theme }) => ({
  padding: '1.5rem 1.5rem 0 1.5rem',
  [theme.breakpoints.up('md')]: {
    padding: '2rem 2rem 0 2rem'
  }
}));
